var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83624 24.75C3.83624 20.3963 8.16749 16.875 13.5 16.875C14.58 16.875 15.6262 17.0212 16.605 17.2912M13.5 13.5C14.9918 13.5 16.4226 12.9074 17.4775 11.8525C18.5324 10.7976 19.125 9.36684 19.125 7.875C19.125 6.38316 18.5324 4.95242 17.4775 3.89752C16.4226 2.84263 14.9918 2.25 13.5 2.25C12.0082 2.25 10.5774 2.84263 9.52252 3.89752C8.46763 4.95242 7.87499 6.38316 7.87499 7.875C7.87499 9.36684 8.46763 10.7976 9.52252 11.8525C10.5774 12.9074 12.0082 13.5 13.5 13.5V13.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9263 20.2275H18.5738M20.25 18.585V21.9488M24.75 20.25C24.75 20.61 24.705 20.9588 24.615 21.2963C24.5138 21.7463 24.3338 22.185 24.0975 22.5675C23.7009 23.2341 23.1376 23.7858 22.4629 24.1685C21.7883 24.5512 21.0256 24.7516 20.25 24.75C19.1424 24.7533 18.0741 24.3396 17.2575 23.5913C16.92 23.2988 16.6275 22.95 16.4025 22.5675C15.9743 21.8705 15.7483 21.0681 15.75 20.25C15.7493 19.6588 15.8652 19.0734 16.091 18.5271C16.3169 17.9808 16.6484 17.4844 17.0664 17.0664C17.4844 16.6484 17.9808 16.3169 18.5271 16.091C19.0734 15.8652 19.6589 15.7493 20.25 15.75C21.5775 15.75 22.7813 16.3238 23.5913 17.2463C24.3113 18.045 24.75 19.1025 24.75 20.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8d4a0e7ae6b0c29f1a3d969697679a75.svg";
export { ForwardRef as ReactComponent };